import type { TypePolicies } from '../utils/types/TypePolicies';

export const typePolicies: TypePolicies = {
  Account: {
    fields: {
      notificationSettings: { merge: true },
      disabledFeatures: { merge: true },
    },
  },
};
